export default __webpack_public_path__ + "static/media/icon_bike_available_active.e2a2ed76.png";